import { QueryKeys } from "@/network/queryKeys";
import { queryClient } from "@/network/queryClient";
import type { tTaskClaim } from "@/types";

const buildSingleTaskClaimQueryKey = (id: string) => [
  QueryKeys.singleTaskClaim,
  { id },
];

const invalidateAll = () => {
  queryClient.invalidateQueries(QueryKeys.singleTaskClaim);
};

export const TaskClaimsCacheService = {
  buildSingleTaskClaimQueryKey,
  invalidateAll,
  addClaim(claim: tTaskClaim) {
    queryClient.setQueryData(buildSingleTaskClaimQueryKey(claim._id), claim);
  },
  replaceClaim(claim: tTaskClaim) {
    queryClient.setQueryData(buildSingleTaskClaimQueryKey(claim._id), claim);
  },
  removeClaim(claim: tTaskClaim) {
    queryClient.invalidateQueries(buildSingleTaskClaimQueryKey(claim._id));
  },
};
